import React from "react";

// Deliberately its own tiny file, importing nothing from three.js/R3F/GSAP.
// KundaliniLookup.jsx imports this statically (as the <Suspense> fallback
// for the *lazy* AstralWorld import) — if it lived inside index.jsx
// alongside the Canvas/Scene code, that static import would drag the whole
// heavy chunk back into the main bundle and defeat the code-split entirely.
export default function AstralWorldLoading() {
  return (
    <div className="astral-world-loading" data-testid="astral-world-loading">
      <div className="astral-world-loading-spinner" />
    </div>
  );
}
